// src/store/reducers/medicineSearch.reducer.ts

import { Medicine } from 'pages/Medicine/Search/searchTypes';
import {
  ADD_TAB,
  REMOVE_TAB,
  ADD_MEDICINE_TO_TAB,
  SET_ACTIVE_TAB,
  LOAD_TABS_FROM_STORAGE,
  UPDATE_MEDICINE_IN_TAB,
  REMOVE_MEDICINE_FROM_TAB,
} from './saleInvoice.types';

export interface Tab {
  id: string;
  name: string;
  selectedMedicines: Medicine[];
}

export interface MedicineSearchState {
  tabs: Tab[];
  activeTabId: string | null;
}

const initialState: MedicineSearchState = {
  tabs: [],
  activeTabId: null,
};

const saveToLocalStorage = (state: MedicineSearchState) => {
  localStorage.setItem('medicineSearchTabs', JSON.stringify(state));
};

export const SaleInvoice = (state = initialState, action: any): MedicineSearchState => {
  switch (action.type) {
    case LOAD_TABS_FROM_STORAGE: {
      return action.payload;
    }

    case ADD_TAB: {
      const newTab: Tab = {
        id: action.payload.id,
        name: action.payload.name,
        selectedMedicines: [],
      };
      const updated = { ...state, tabs: [...state.tabs, newTab], activeTabId: newTab.id };
      saveToLocalStorage(updated);
      return updated;
    }

    case REMOVE_TAB: {
      const tabs = state.tabs.filter((tab) => tab.id !== action.payload);
      const activeTabId = tabs.length > 0 ? tabs[tabs.length - 1].id : null;
      const updated = { ...state, tabs, activeTabId };
      saveToLocalStorage(updated);
      return updated;
    }

    case SET_ACTIVE_TAB: {
      const updated = { ...state, activeTabId: action.payload };
      saveToLocalStorage(updated);
      return updated;
    }

    case ADD_MEDICINE_TO_TAB: {
      const { tabId, medicine } = action.payload;
      const tabs = state.tabs.map((tab) =>
        tab.id === tabId && !tab.selectedMedicines.find((m) => m.id === medicine.id)
          ? { ...tab, selectedMedicines: [...tab.selectedMedicines, medicine] }
          : tab,
      );
      const updated = { ...state, tabs };
      saveToLocalStorage(updated);
      return updated;
    }

    case UPDATE_MEDICINE_IN_TAB: {
      const { tabId, medicine } = action.payload;
      const tabs = state.tabs.map((tab) =>
        tab.id === tabId
          ? {
              ...tab,
              selectedMedicines: tab.selectedMedicines.map((m) =>
                m.id === medicine.id ? { ...m, ...medicine } : m,
              ),
            }
          : tab,
      );
      const updated = { ...state, tabs };
      saveToLocalStorage(updated);
      return updated;
    }

    case REMOVE_MEDICINE_FROM_TAB: {
      const { tabId, medicineId } = action.payload;
      const tabs = state.tabs.map((tab) =>
        tab.id === tabId
          ? {
              ...tab,
              selectedMedicines: tab.selectedMedicines.filter((m) => m.id !== medicineId),
            }
          : tab,
      );
      const updated = { ...state, tabs };
      saveToLocalStorage(updated);
      return updated;
    }

    default:
      return state;
  }
};
